import { createContext, useContext, useState, ReactNode } from 'react';

interface ProfileDrawerContextType {
  isOpen: boolean;
  userId: string | null;
  openProfileDrawer: (userId: string) => void;
  closeProfileDrawer: () => void;
}

const ProfileDrawerContext = createContext<ProfileDrawerContextType | undefined>(undefined);

export const ProfileDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);

  const openProfileDrawer = (targetUserId: string) => {
    setUserId(targetUserId);
    setIsOpen(true);
  };

  const closeProfileDrawer = () => {
    setIsOpen(false);
    // Don't clear userId immediately to prevent flashing during close animation
    setTimeout(() => setUserId(null), 300);
  };

  return (
    <ProfileDrawerContext.Provider
      value={{
        isOpen,
        userId,
        openProfileDrawer,
        closeProfileDrawer,
      }}
    >
      {children}
    </ProfileDrawerContext.Provider>
  );
};

export const useProfileDrawer = () => {
  const context = useContext(ProfileDrawerContext);
  if (context === undefined) {
    throw new Error('useProfileDrawer must be used within a ProfileDrawerProvider');
  }
  return context;
};
